import PLP from "./PLP";

export default PLP;
